<nz-form-item class="input-label-wrapper">
  <nz-form-label class="regular">
    <span>{{ label() }}</span>
    @if (optional()) {
      <span class="silver-chalice-text">
        ({{ i18n.langString("optional") }})
      </span>
    }
  </nz-form-label>

  <nz-input-group>
    <input
      nz-input
      [ngModel]="value()"
      [required]="!optional()"
      [placeholder]="label()"
      [name]="key()"
      [id]="key()"
      #ctrl="ngModel"
      (input)="onInputChange($event.target.value)"
      [ngModelOptions]="{ standalone: true }"
    />
  </nz-input-group>
  @if (ctrl.touched && ctrl.errors?.["required"]) {
    <div class="field-error">Required</div>
  }
</nz-form-item>
